<i class="material-icons md-24 align-text-bottom secondary" (click)="refresh()">refresh</i>
